import React, { useState } from "react";
import { useSelector } from "react-redux";
import titleImage from "../assets/title_image.png";
import GroupStage from "./GroupStage";
import KnockOut from "./KnockOut";

function MainBody() {
  const gameStep = useSelector((state) => state.team.step);
  const [titleImageBlur, setTitleImageBlur] = useState(false);
  return (
    <main className="container-full d-flex justify-content-around px-0 cont-principal">
      <section className="container cont-layout">
   
        {gameStep.groupStage ? <GroupStage /> : <KnockOut />}
        <section className="content-msgs">
          <section className="d-none d-md-block empty-space"></section>
        </section>
      </section>
    </main>
  );
}

export default MainBody;
